





































import { Component, Prop, Vue } from "vue-property-decorator";
import BackLink from "@/components/app/BackLink.vue";
import Preloader from "@/components/app/Preloader.vue";
import { ForecastModalVueGB } from "@/extensions/contract/ForecastModalVueGB";

@Component({
  components: { BackLink, Preloader }
})
export default class ForecastModal extends ForecastModalVueGB {
  
  async mounted(): Promise<void> {
    await this.fetchForecastData(this.contractId);
  }

}
